document.addEventListener('DOMContentLoaded', () => {
  const ctaButton = document.querySelector('.lp202604__cta-button');
  const fixedButton = document.querySelector('[data-lp202604-fixed-button]');

  if (!ctaButton || !fixedButton) return;

  const href = ctaButton.getAttribute('href');

  if (href) {
    fixedButton.setAttribute('href', href);
  }
});